import React from "react";
import { MyGlobalContext } from "../Context";
import Loading from "../components/Loading/Loading";
import Search from "../components/Home/Search";
import "../components/Home/Home.css";
import Cocktail from "../components/Home/cocktail";
import Slider from "../components/Home/Slider/Slider";

const Home = () => {
  const { loading, cocktails } = MyGlobalContext();
  if (loading) {
    return (
      <div className="home">
        <Slider />
        <Search />
        <Loading />
      </div>
    );
  }
  if (cocktails.length < 1) {
    return (
        <>
        <Slider />
        <Search cocktails={cocktails}/>
        <h1 className="h1-cocktail"> No cocktail match to your search criteria</h1>        
        </>
    );
  }
  return (
    <div className="home">
      <Slider />
      <Search />
      <Cocktail cocktails={cocktails} />
    </div>
  );
};

export default Home;
